import React from 'react';

var Pie = require("react-chartjs").Pie;
var Chart = require('chartjs');

var pieOptions = {
  animation: false,
  responsive: false
};

const title = Object.assign({fontFamily: 'Oswald'}, {fontSize: '40'}, {color:
                            'black'}, {textDecoration: 'none'})

var rec_colors = ['#011f4b', '#03396c', '#005b96', '#6497b1', '#b3cde0'];
var sent_colors=['#b62020', '#cb2424', '#fe2e2e', '#fe5757', '#fe8181'];

const sent_style = Object.assign({fontFamily: 'Oswald'}, {fontSize: '32'},
                            {color: '#ab5b5b'})
const rec_style = Object.assign({fontFamily: 'Oswald'}, {fontSize: '32'},
                            {color: '#005b96'})
const reg_style = Object.assign({fontFamily: 'Oswald'}, {fontSize: '32'})

const PieChart = React.createClass({
  insert_colors(array, colors) { 
    const len = colors.length;
    var x;

    for (x in array) {
      array[x].color = colors[x % len]
    }

    return array
  },
  pieTitle() {
    var raw;
    var titleStyle;
    var who;
    var percent;
    if (this.props.trade.sentValue > this.props.trade.recValue) {
      raw = this.props.trade.sentValue/this.props.trade.recValue;
      titleStyle = rec_style;
      who = 'Recieving';
    }
    else {
      raw = this.props.trade.recValue/this.props.trade.sentValue
      titleStyle = sent_style;
      who = 'Sending';
    }

    if (raw === 1) {
      return <h2 className="text-center" style={reg_style}>This Trade is Even</h2>
    }
    if (raw < 1.01) {
      percent = 'Slight';
      return <h2 className="text-center" style={titleStyle}>{who} Player: Slight Advantage</h2>
    }
    else if (isFinite(raw)) {
      percent = String(((raw - 1)*100).toFixed(0));
      return <h2 className="text-center" style={titleStyle}>{who} Player: {percent}% Advantage</h2>
    }
  },
  render: function() {
    if (this.props.rec.length > 0 | this.props.sent.length > 0) {
      return (
        <div className="text-center">
          <strong>{this.pieTitle()}</strong>
            <Pie 
              data={this.insert_colors(this.props.rec, rec_colors).concat(this.insert_colors(this.props.sent, sent_colors))} 
              options={pieOptions} redraw
              width="300" height="300" />
        </div>
      )
    }
    else {
      return (
        <div className="text-center">
          <p style={title}><br/>From the creators of<br/><a href="https://www.fantasymath.com">Fantasy Math</a></p>
        </div>
      )
    }
 }
});

export default PieChart;



// WEBPACK FOOTER //
// ./src/components/PieChart.js